import { permissionsActions } from "./AuthInterface"

export interface IPlan {
    id: PlanTypes,
    name: string,
    price: number,
    paddlePriceId: string,
    benefits: string[]
    remainingTime: IPlanRemainingTime
    allowedActions: permissionsActions[]
}
export interface PlansModalFace {
    isLoading?: boolean,
    title?: string,
    subtitle?: string
}

export interface IconTextFace {
    icon?: string | React.ReactNode,
    text: string | React.ReactNode
};

export interface PriceTagFace {
    price: number,
    pricePer?: string,
}

export type PlanCardFace = {
    plan: IPlan
    handleSubscribe: () => void,
    publicView?: boolean
    selectedPlanId: PlanTypes | undefined
}

export enum PlanTypes {
    free = 1,
    standard = 2,
    premium = 4,
}
export interface IPlanRemainingTime {
    days: number,
    hours: number
}
